import React, { useEffect, useState } from "react";
import { Box, styled } from "@mui/material";
import i18n from "i18next";

import GermanyFlag from "assets/icons/de_flag_tall.png";
import UKFlag from "assets/icons/uk_flag.png";

const flags = [
  { code: "de", icon: GermanyFlag },
  { code: "en", icon: UKFlag },
];

const FlagButton = styled("img")<{ selected: boolean }>(({ selected }) => ({
    width: "70px",
    height: "70px",
    borderRadius: "50%",
    filter: selected ? "none" : "grayscale(100%)",
    border: selected ? "3px solid #8CA895" : "2px solid #ccc",
    cursor: "pointer",
    transition: "transform 0.2s ease, border 0.2s ease",
    boxShadow: selected ? "0px 0px 10px rgba(0,0,0,0.2)" : "none",
    "&:hover": {
      transform: "scale(1.1)",
    },
  }));
  
  const FlagContainer = styled(Box)({
    display: "flex",
    gap: "1.5rem",
    justifyContent: "center",
    alignItems: "center",
    padding: "2rem 0",
  });
  

const LanguageSelector = () => {
  const [selectedLang, setSelectedLang] = useState<string>("");

  useEffect(() => {
    const storedLang = localStorage.getItem("selectedLanguage");
    const browserLang = navigator.language.startsWith("de") ? "de" : "en";
    const lang = storedLang || browserLang;

    setSelectedLang(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem("selectedLanguage", lang);
  }, []);

  const handleLanguageChange = (code: string) => {
    setSelectedLang(code);
    i18n.changeLanguage(code);
    localStorage.setItem("selectedLanguage", code);
  };

  return (
    <FlagContainer>
      {flags.map(({ code, icon }) => (
        <FlagButton
          key={code}
          src={icon}
          alt={`${code}-flag`}
          selected={selectedLang === code}
          onClick={() => handleLanguageChange(code)}
        />
      ))}
    </FlagContainer>
  );
};

export default LanguageSelector;
